import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {AboutPage} from "~/app/pages/about/about.page";
import {PrivacyPolicyPage} from "~/app/pages/privacy-policy/privacy-policy.page";
import {TermsOfUsePage} from "~/app/pages/terms-of-use/terms-of-use.page";
import {SettingsPage} from "~/app/pages/settings/settings.page";
import {ContactUsPage} from "~/app/pages/contact-us/contact-us.page";
import {LogoutPage} from "~/app/pages/logout/logout.page";
import {LoginPage} from "~/app/pages/login/login.page";
import {SignupPage} from "~/app/pages/signup/signup.page";
import {LocationPage} from "~/app/pages/location/location.page";
import {ForgotPasswordPage} from "~/app/pages/forgot-password/forgot-password.page";
import {ValidatePage} from "~/app/pages/validate/validate.page";
import {ReferrerPage} from "~/app/pages/referrer/referrer.page";
import {SearchingPage} from "~/app/pages/searching/searching.page";
import {WelcomePage} from "~/app/pages/welcome/welcome.page";
// import {OffersPage} from "~/app/pages/offers/offers.page";
import {OfferCouponOpenPage} from "~/app/pages/offer-coupon-open/offer-coupon-open.page";
import {HomePage} from "~/app/pages/home/home.page";
import {OfferPage} from "~/app/pages/offer/offer.page";
import {AllOffersPage} from "~/app/pages/all-offers/all-offers.page";

const routes: Routes = [
    { path: "", redirectTo: "/home", pathMatch: "full" },
    { path: "home", component: HomePage, data: {hideNav: true} },
    { path: "about", component: AboutPage },
    { path: "contact-us/:reason", component: ContactUsPage },
    { path: "searching", component: SearchingPage },
    { path: "searching/:offerId", component: SearchingPage },
    // { path: "offers", component: OffersPage },
    { path: "offers/:offerId", component: OfferCouponOpenPage },
    // { path: "no-offers", component: NoOffersPage },
    { path: "location", component: LocationPage },
    // { path: "show-cashier/:offerId", component: ShowCashierPage },
    // { path: "share/:offerId", component: SharePage },
    // { path: "share-app", component: ShareAppPage },
    { path: "settings", component: SettingsPage },
    { path: "logout", component: LogoutPage },
    { path: "login", component: LoginPage, data: {hideNav: true}},
    { path: "signup", component: SignupPage, data: {hideNav: true}},
    { path: "validate", component: ValidatePage },
    { path: "referrer", component: ReferrerPage },
    { path: "forgot-password", component: ForgotPasswordPage, data: {hideNav: true}},
    { path: "welcome", component: WelcomePage, data: {hideNav: true}},
    // { path: "sponsor", component: SponsorPage },
    // { path: "sponsor-video", component: SponsorVideoPage },
    // { path: "sponsor-video/:offerId", component: SponsorVideoPage },
    // { path: "thanks/:offerId", component: ThanksPage },
    { path: "privacy-policy", component: PrivacyPolicyPage },
    { path: "terms-of-use", component: TermsOfUsePage },
  { path: "offer/:offerId", component: OfferPage, data: {hideNav: true}},
  { path: "all-offers", component: AllOffersPage, data: {hideNav: true}},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
